<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="latentStudentBrowseListPush"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
  >
    <v-column-time value="访问时间"/>

    <v-column-student label="访问学员" link-page-id="student_id"/>

    <el-table-column label="手机号" prop="phone" width="164px"/>

    <el-table-column label="访问页面" width="164px">
      <template v-slot="{ row }">{{ row.page_name || '' }}</template>
    </el-table-column>

    <el-table-column label="相关门店" width="164px">
      <template v-slot="{ row }">{{ row.store_name || '-' }}</template>
    </el-table-column>

    <v-column-avatar label="相关老师" avatar-key="teacher_avatar" nickname-key="teacher_nickname"/>

    <el-table-column label="相关课程" width="164px">
      <template v-slot="{ row }">
        <router-link v-if="row.course_id" class="primary-color" :to="courseManageTo(row.course_id)">
          {{ row.course_name }}
        </router-link>
        <template v-else>-</template>
      </template>
    </el-table-column>

    <el-table-column label="相关视频">
      <template v-slot="{ row }">{{ row.title || '-' }}</template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>访问学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>访问时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>访问页面</span>
              <span>{{ v.page_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>相关门店</span>
              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>相关老师</span>
              <v-avatar-nickname
                :value="v.teacher_avatar"
                :nickname="v.teacher_nickname"
                :is-center="true"
                :link-page-name="RouteConfig.teacherDetail.name"
                :link-page-id="v.teacher_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>相关课程</span>
              <router-link v-if="v.course_id" class="primary-color" :to="RouteConfig.courseManage.to(v.course_id)">
                {{ v.course_name }}
              </router-link>
            </div>

            <div class="list-item-detail">
              <span>相关视频</span>
              <span>{{ v.title || '' }}</span>
            </div>

            <div class="list-item-detail"></div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { getStudentPageRecords } from '@/api/student';

export default {
  name: RouteConfig.latentStudentBrowseList.name,
  data: () => ({
    RouteConfig,
    latentStudentBrowseListPush: RouteConfig.latentStudentBrowseList.push,
    courseManageTo: RouteConfig.courseManage.to,
    isLoading: false,
    isShowDialog: false,
    isSavingIds: [],
    isSettingIds: [],
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    currentStudentId: 0,
    teacher: {
      teacher_id: 0,
    },
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.latentStudentBrowseList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      queryList.is_latent = 1;
      this.isLoading = true;
      const { isError, data } = await getStudentPageRecords(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>

<style src="./index.css" scoped/>
